import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AngularFireModule } from "angularfire2";
import { environment } from "../environments/environment";
import { AngularFireDatabaseModule } from "angularfire2/database";
import { MatDialogModule, MatDialog } from "@angular/material";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { LangService } from "./lang.service";

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule,
  MatFormFieldModule
} from "@angular/material";
import "hammerjs";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";
import { FlexLayoutModule } from "@angular/flex-layout";

import { AppComponent } from "./app.component";
import { CHeadComponent } from "./c-head/c-head.component";
import { CHeroComponent } from "./home/c-hero/c-hero.component";
import { CNewsComponent } from "./home/c-news/c-news.component";
import { CFooterComponent } from "./c-footer/c-footer.component";
import { HomeComponent } from "./home/home.component";
import { RouterModule } from "@angular/router";
import { routing } from "./app.routing";
import { ContactsComponent } from "./contacts/contacts.component";
import { CalendarComponent } from "./calendar/calendar.component";
import { ResultsComponent } from "./results/results.component";
import { AboutUsComponent } from "./about-us/about-us.component";
import { NewMemberComponent } from "./about-us/new-member/new-member.component";
import { OurServicesComponent } from "./about-us/our-services/our-services.component";
import { RacesComponent } from "./calendar/races/races.component";
import {
  R1Component,
  Registration1,
  Registration200
} from "./calendar/races/r1/r1.component";

import { ThankYouComponent } from "./calendar/races/r1/thankYou.component";

import { VilniusInfoComponent } from "./calendar/races/r1/raceSingle.component";
import { DocumentsComponent } from "./documents/documents.component";
import { MediaComponent } from "./media/media.component";
import { RacesService } from "./calendar/races/raceServices/races.service";
import { HttpModule } from "@angular/http";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { NgxGalleryModule } from "ngx-gallery";
import { PhotoGalleryComponent } from "./media/photo-gallery/photo-gallery.component";
import { MediaServiceService } from "./media/media-service.service";
import { BannerComponent } from "./home/banner/banner.component";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "/assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    CHeadComponent,
    CHeroComponent,
    CNewsComponent,
    CFooterComponent,
    HomeComponent,
    ContactsComponent,
    CalendarComponent,
    ResultsComponent,
    AboutUsComponent,
    NewMemberComponent,
    OurServicesComponent,
    RacesComponent,
    R1Component,
    DocumentsComponent,
    MediaComponent,
    Registration1,
    Registration200,
    ThankYouComponent,
    VilniusInfoComponent,
    PhotoGalleryComponent,
    BannerComponent
  ],
  imports: [
    BrowserModule,
    FlexLayoutModule,
    AngularFireModule.initializeApp(environment.firebase),
    routing,
    RouterModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatSidenavModule,
    MatMenuModule,
    MatIconModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    MatFormFieldModule,
    HttpModule,
    AngularFireDatabaseModule,
    HttpClientModule,
    HttpClientModule,
    NgxGalleryModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],

  entryComponents: [Registration1, Registration200, ThankYouComponent],
  exports: [MatSnackBarModule],
  providers: [RacesService, LangService, MediaServiceService],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts